// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__P85jj","footer":"NavbarSimple_footer__au-Ot","link":"NavbarSimple_link__IKuWR","linkIcon":"NavbarSimple_linkIcon__c3OT7"};